import { FormSection } from "$components/form-section";
import type { Territory } from "$global-providers/config-provider/provider";
import { useIntl } from "react-intl";
import { RHFAddressFields } from "./RHFAddressFields";

export const AddressSection: React.FC<{
  territory: Territory;
  fieldNames: {
    country: string;
    addressLine1: string;
    addressLine2: string;
    addressLine3: string;
    addressLine4: string;
  };
}> = ({ territory, fieldNames }) => {
  const { formatMessage } = useIntl();

  return (
    <FormSection
      title={formatMessage({
        id: "patient.generalSection.title",
        defaultMessage: "Patient Address",
      })}
    >
      <RHFAddressFields
        required
        territory={territory}
        fieldNames={{
          country: fieldNames.country,
          addressLine1: fieldNames.addressLine1,
          addressLine2: fieldNames.addressLine2,
          addressLine3: fieldNames.addressLine3,
          addressLine4: fieldNames.addressLine4,
        }}
      />
    </FormSection>
  );
};
